import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { WithdrawalPaymentFilesApiAdapter } from '../adapters';
import type { WithdrawalPaymentFilesFilters } from '../models';

export const WITHDRAWAL_PAYMENT_FILES_QUERY_KEY = 'withdrawalPaymentFiles';

export const useWithdrawalPaymentFilesInfinite = (filters: WithdrawalPaymentFilesFilters = {}) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const apiAdapter = useMemo(() => new WithdrawalPaymentFilesApiAdapter(httpClient), [httpClient]);

  return useInfiniteQuery({
    queryKey: [WITHDRAWAL_PAYMENT_FILES_QUERY_KEY, 'infinite', filters],
    queryFn: async ({ pageParam }) => {
      const response = await apiAdapter.getPaymentFiles({
        ...filters,
        page: pageParam as number,
        perPage: 25,
      });
      return {
        data: response.data,
        meta: {
          total: response.meta?.total ?? response.data.length,
          currentPage: response.meta?.current_page ?? 1,
          lastPage: response.meta?.last_page ?? 1,
        },
      };
    },
    getNextPageParam: (lastPage) => {
      const { currentPage, lastPage: last } = lastPage.meta;
      if (currentPage < last) {
        return currentPage + 1;
      }
      return undefined;
    },
    initialPageParam: 1,
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
  });
};
